import { WorkflowRestoreVersionDetails } from "store/workflow";
import { getObject, remove, RepositoryKey, setObject } from "utils/repository";

export function getWorkflowRestoreVersionDetails(): WorkflowRestoreVersionDetails | null {
    const workflow: WorkflowRestoreVersionDetails | null = getObject(RepositoryKey.WORKFLOW_RESTORE_VERSION_DETAILS);
    if (workflow == null) {
        return workflow;
    }
    return workflow;
}

export function setWorkflowRestoreVersionDetails(details: WorkflowRestoreVersionDetails): void {
    setObject(RepositoryKey.WORKFLOW_RESTORE_VERSION_DETAILS, details);
}

export function clearWorkflowRestoreVersionDetails(): void {
    remove(RepositoryKey.WORKFLOW_RESTORE_VERSION_DETAILS);
}
